import { Trans } from '@lingui/react/macro';

import Message from '@/design_system/Message';

export const PleaseSelectAnOptionError = () => {
  return (
    <Message type="error">
      <Trans id="please-select-option.error">Please select an option</Trans>
    </Message>
  );
};
